import img1 from "./20438a3b-3f74-4aa9-a63c-374e57e76dd3.jpg";
import img2 from "./3fa6cd37-4d8e-4062-af3d-20cc4479d7bb.jpg";
import img3 from "./516c3268-027e-44b4-8f06-29712966c36d.jpg";
import img4 from "./81c8abf4-4e42-4db4-abf2-07bdbd956c8d.jpg";

export const img = [img1, img2, img3, img4];
